import { Button, Callout, Flex, Spinner, Text } from "@radix-ui/themes";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { routes } from "../../../routes";
import { authClient } from "../client/auth-client";
import { AuthErrorMessage } from "../components/auth-error-message.component";
import { AuthRoot } from "../auth-root.component";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const {
    mutate: verifyEmail,
    isIdle,
    isPending,
    isSuccess,
    isError,
    error,
  } = useMutation({
    mutationFn: async (verificationToken: string) => {
      await authClient.verifyEmail({
        query: { token: verificationToken },
      });
      await authClient.getSession();
    },
  });

  useEffect(() => {
    if (!token || !isIdle) {
      return;
    }
    verifyEmail(token);
  }, [isIdle, token, verifyEmail]);

  return (
    <AuthRoot title="E-Mail Verifizierung">
      {!token && (
        <AuthErrorMessage message="Der Bestätigungslink ist ungültig." />
      )}

      {token && isPending && (
        <Flex align="center" gap="2">
          <Spinner />
          <Text>E-Mail wird bestätigt...</Text>
        </Flex>
      )}

      {isSuccess && (
        <Callout.Root color="green">
          <Callout.Text>
            Ihre E-Mail-Adresse wurde bestätigt. Sie sind jetzt eingeloggt.
          </Callout.Text>
        </Callout.Root>
      )}

      {isError && <AuthErrorMessage error={error} />}

      <Button asChild size="3" variant="soft">
        <NavLink to={routes.home}>Zur Startseite</NavLink>
      </Button>
    </AuthRoot>
  );
}
